"use strict";

module.exports = function(chart) {
  if (!chart.options.reOrderableChart) {
    return;
  }

  setTimeout(function () {
    const series = chart.series;
    const visibleSeries = series.filter(series => series.visible === true);

    // visibleSeries.map(series => console.log(series.name));

    const accumulator = {};
    visibleSeries.map(series => series.data.map(point => accumulator[point.category] = (accumulator[point.category] || 0) + point.y));
    const sortedAccumulator = Object.entries(accumulator).sort((a, b) => b[1] - a[1]);
    sortedAccumulator.map(c => c["category"] = c[0]);

    function sortValuesByAccumulator(a, b) {
      const aCountry = sortedAccumulator.map(e => e.category).indexOf(a["category"]);
      const bCountry = sortedAccumulator.map(e => e.category).indexOf(b["category"]);
      return aCountry > bCountry ? 1 : -1;
    }

    const sortedWaterData = series[0].data.sort(sortValuesByAccumulator);
    sortedWaterData.map((e, i) => e.update({ x: i, index: i }, false));

    const sortedWastewaterData = series[1].data.sort(sortValuesByAccumulator);
    sortedWastewaterData.map((e, i) => e.update({ x: i, index: i }, false));

    const sortedStormData = series[2].data.sort(sortValuesByAccumulator);
    sortedStormData.map((e, i) => e.update({ x: i, index: i }, false));

    chart.yAxis[0].isDirty = true;
    chart.xAxis[0].isDirty = true;
    chart.xAxis[0].setCategories(sortedWaterData.map(e => e.category));
  }, 0);
};
